export default __webpack_public_path__ + "50c0912c1f9304a02354521a884e1ffb.svg";